var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mf-loading-dialog',{attrs:{"loading":_vm.$apollo.queries.voucher.loading}},[_c('edit',{attrs:{"voucher":_vm.voucher}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }